export default __webpack_public_path__ + "static/media/NETWSERV_Dashboard.c22db92f.svg";